import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";
import { Strings } from "../../utils/strings";

type props = {};

export const OTPSuccessVerificationMsg: React.FC<props> = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        marginTop: 20,
        alignItems: "center",
      }}>
      <div
        style={{
          height: 20,
          width: 20,
          borderRadius: 10,
          backgroundColor: Colors.green,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <TCText style={{ color: "white", fontSize: 10 }} value="✔" />
      </div>
      <TCText
        style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
        value={Strings.OTP_VRIFICATION_DONE}
      />
    </div>
  );
};
